<template>
  <div style="zoom:0.9;">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $tc("add") }} {{ $t("hardwareLocations") }}
      </div>
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-3 align-self-center mb-2">
          <div class="dropdown-curve-container">
            <label
              :class="selectedCinema ? 'shift-up' : ''"
              style="font-weight: 600"
              >{{ $tc("cinema", 1) }}</label
            >
            <multiselect
              :options="cinemas"
              v-model="selectedCinema"
              :searchable="true"
              label="cine_name"
              track-by="cine_id"
              placeholder=""
              @select="onSelectCinema($event, 'select')"
              @remove="onSelectCinema($event, 'remove')"
            ></multiselect>
            <p class="error_message"></p>
          </div>
        </div>
        <div class="col-lg-6 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="location_name"
                type="text"
                name="location_name"
                id="location_name"
                v-validate="'required'"
              />
              <label>{{ "Location Name" }}</label>
            </div>
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('location_name')">{{
              errors.first("location_name")
            }}</span>
          </p>
        </div>
        <div class="col-lg-6 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="report_code"
                type="text"
                name="report_code"
                id="report_code"
                v-validate="'required'"
              />
              <label>{{ "Report Code" }}</label>
            </div>
          </div>
          <p class="error_message">
          </p>
        </div>
        <div class="col-lg-6 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="gl_account"
                type="text"
                name="gl_account"
                id="gl_account"
                v-validate="'required'"
              />
              <label>{{ "GL Account" }}</label>
            </div>
          </div>
          <p class="error_message">
          </p>
        </div>
        <div class="col-lg-6 col-xl-3 align-self-center mb-2">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="gl_desc"
                type="text"
                name="gl_desc"
                id="gl_desc"
                v-validate="'required'"
              />
              <label>{{ "GL Description" }}</label>
            </div>
          </div>
          <p class="error_message">
          </p>
        </div>

        <div class="col-lg-6 col-xl-3 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">Active</label>
            <b-form-checkbox
              unchecked-value="N"
              value="Y"
              v-model="hl_is_active"
              name="check-button"
              switch
              class="j-checkbox"
            ></b-form-checkbox>
          </div>
        </div>
        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit(false)"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="resetForm()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="hardware-locations"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import MovieService from "@/services/MovieService";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {},
  data() {
    return {
      cinemas: [],
      selectedCinema: "",
      cinema_id: null,
      btenable: false,
      location_name: "",
      report_code: "",
      gl_account: "",
      gl_desc: "",
      hl_is_active: "Y",
      submitted: false,
    };
  },
  computed: {},
  beforeMount() {},
  mounted() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.getCinemaList(obj);
  },
  methods: {
    getCinemaList: function (cine_id) {
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.cinemas = data.Records;
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch((error) => {
          console.log("show error2 :", error);
        });
    },
    onSelectCinema(event, type) {
      if (type == "remove") {
        this.cinema_id = null;
        this.selectedCinema = "";
      } else {
        this.cinema_id = event.cine_id;
        this.selectedCinema = event;
      }
    },
    OnFinalSubmit: function (redirect) {
      this.submitted = true;
      if (!this.cinema_id) {
        this.$toasted.show("Please Select Cinema");
        return;
      } else if (!this.location_name) {
        this.$toasted.show("Please Enter Location");
        return;
      }
      this.$validator.validate().then((valid) => {
        if (valid) {
          let loader = this.$loading.show();
          let payload = {
            cinema_id: this.cinema_id,
            location_name: this.location_name,
            report_code: this.report_code,
            gl_account: this.gl_account,
            gl_desc: this.gl_desc,
            hl_is_active: this.hl_is_active,
          };
          MasterService.AddHardwareLocation(payload)
            .then((response) => {
              const { data } = response;
              if (data && data.status) {
                this.resetForm();
                if (redirect) {
                  this.$router.push({
                    path: "/master/hardware-locations",
                  });
                }
                this.$toasted.show(data.message);
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch((err) => {
              console.log("Error:", err);
            })
            .finally(() => {
              loader.hide();
              this.btenable = false;
              this.submitted = false;
            });
        }
      });
    },
    resetForm: function () {
      this.location_name = "";
      this.report_code = "";
      this.gl_account = "";
      this.gl_desc = "";
      this.hl_is_active = "Y";
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/HardwareComponents/AddHardwareLocation.vue